/* eslint-disable react/style-prop-object */
import React, { useContext } from "react";
import Button from "../../../Helpers/Button/Button";
import { popupcontext } from "../../../../context/Popupscontext";
import { useMap } from "react-leaflet";
import trans from "../../../../utils";

export default function GeofenceFooter({ AddGeo, submitAttempt, isLoading }) {
	let { handleClose } = useContext(popupcontext);
	const map = useMap();
	return (
		<div>
			<div className="d-flex flex-row-reverse px-3 my-3 gap-8">
				<Button
					type={"primary"}
					text={trans("Save")}
					htmlType="submit"
					loading={isLoading}
				/>
				<Button
					type={"default"}
					htmlType="button"
					text={trans("Cancel")}
					onClick={() => {
						handleClose("editing");
						map.dragging.enable();
					}}
				/>
			</div>
			{submitAttempt && !AddGeo.isValid && (
				<div className="validation text-end pe-3">
					{trans("Please Check Required Inputs")}
				</div>
			)}
		</div>
	);
}
